// @flow

export default {
  LOCAL: 'local',
  ACCEPTATION: 'acceptance',
  PRODUCTION: 'production',
  END_TO_END: 'e2e'
};
